import React from "react";

import { Button } from "@/components/ui/Button";

// One row in a popover menu: a label, the sentence that says what it does, and
// the icon. `hint` doubles as the reason a disabled item is disabled, so a
// reader never has to guess why an action is closed to them.
const MenuItem = ({ icon: Icon, label, hint, onClick, disabled, iconSpinning }) => (
    <Button
        onClick={onClick}
        disabled={disabled}
        className="w-full flex items-start gap-2 rounded-md px-2 py-1.5 text-left text-[13px] text-text-primary hover:bg-background-icon/60 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent"
    >
        <Icon
            size={14}
            aria-hidden="true"
            className={`mt-0.5 shrink-0 ${iconSpinning ? "animate-spin" : ""}`}
        />
        <div className="min-w-0">
            <div className="font-medium">{label}</div>
            {hint && (
                <div className="text-[11px] text-text-secondary mt-0.5">{hint}</div>
            )}
        </div>
    </Button>
);

export default MenuItem;
